export default {
  data() {
    return {
      T:null,
      maxArtistsOnPage: $('#app-wrapper').attr('count_on_page'),//SetsPaginationMix
      is_pro_page: $('#app-wrapper').attr('is_pro_page'),
    }
  },

  created: function () {
    this.$store.dispatch('getUserId').then(() => {})
    this.$store.dispatch('getArtists');
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/ArtistsListMix.js
// module id = null
// module chunks = 